/** Menu: card-like list, rounded items with navy.50 hover. */
export const Menu = {
  baseStyle: {
    list: { bg: "surface.card", borderRadius: "lg", boxShadow: "lg", border: "none", py: 2, minW: "12rem" },
    item: {
      mx: 2,
      w: "auto",
      borderRadius: "md",
      px: 3,
      py: 2.5,
      fontSize: "0.875rem",
      fontWeight: 600,
      color: "text.primary",
      _hover: { bg: "navy.50" },
      _focus: { bg: "navy.50" },
      _active: { bg: "navy.100" },
    },
    // Explicit values (the \`label\` style): textStyle has the lowest priority and would lose to Chakra's default groupTitle.
    groupTitle: {
      fontSize: "0.75rem",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      lineHeight: 1.2,
      color: "text.muted",
      px: 3,
      py: 2,
      mx: 2,
    },
    divider: { borderColor: "border.default", my: 2 },
  },
};
